import Keycloak from 'keycloak-js';

export const hubKeycloak = new Keycloak({
  url: import.meta.env.VITE_KEYCLOAK_URL ?? 'http://localhost:8080',
  realm: import.meta.env.VITE_KEYCLOAK_REALM ?? 'te-presta',
  clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID ?? 'hub',
});

// Same proven pattern as TePresta: login-required (no redirect-based
// check-sso, which caused state-mismatch login loops with a live SSO cookie).
export const KEYCLOAK_INIT_OPTIONS = {
  onLoad: 'login-required' as const,
  silentCheckSsoFallback: false,
  checkLoginIframe: false,
};
